/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskSubmissionVersionSummary } from './taskSubmissionVersionSummary';

export type GenericApiResponseListTaskSubmissionVersionSummaryData = TaskSubmissionVersionSummary[] | null;
